import { render, staticRenderFns } from "./hrLogin.vue?vue&type=template&id=8b6631d6&scoped=true"
import script from "./hrLogin.vue?vue&type=script&lang=js"
export * from "./hrLogin.vue?vue&type=script&lang=js"
import style0 from "./hrLogin.vue?vue&type=style&index=0&id=8b6631d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6631d6",
  null
  
)

export default component.exports